import {
    DATASET_BUILDER_ADD_ALIAS_COLS,
    DATASET_BUILDER_ADD_MODIFY_SELECTED_TABLE,
    DATASET_BUILDER_CLEAR_AFTER_MODAL_HIDING,
    DATASET_BUILDER_CLEAR_QUERY_FETCHES,
    DATASET_BUILDER_DELETE_SELECTED_TABLE,
    DATASET_BUILDER_REMOVE_ALIAS_COL,
    DATASET_BUILDER_REORDER_ALIAS_COLS,
    DATASET_BUILDER_SELECT_CURRENT_TABLE,
    DATASET_BUILDER_UPDATE_ALIAS_COL,
    DATASET_BUILDER_WIZARD_QUERY_APPEND_QUERY,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET,
    DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE,
    DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,
    DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE,
    DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE,
    DATASET_BUILDER_CLEAN_SELECTED_TABLES,
    DATASET_BUILDER_WIZARD_QUERY_REPLACE_QUERY,
    DATASET_BUILDER_GET_DATASET,
    DATASET_BUILDER_GET_TABLE_VIEW_COLUMNS_FOR_MODAL,
    DATASET_BUILDER_UPDATE_IN_DB,
    DATASET_BUILDER_ERASE_UPDATE_IN_DB,
    DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET_ALL
} from "./actions";
import {REQUEST_ERROR, REQUEST_SUCCESS} from "../../../../middlewares/api/actions";
import {
    FILTER_MODE_IN,
} from "../../../../utils/sdmxJson";
import {QUERY_FORM_FILTER_MODE_PLAIN, QUERY_FORM_FILTER_MODE_TREE} from "../../../../components/query-form";
import _ from "lodash";
import {v4 as uuidv4} from "uuid";
import {wrapColumnWithDBSpecificParenthesis} from "./components/utils";

const UnionModalPropsReducer = (state = {
    filter: null,
    filterTemp: null,
    treeFilter: {},
    treeFilterTemp: {},
    filterMode: QUERY_FORM_FILTER_MODE_PLAIN,
    query: "",
    filterStr: "",
    aliasCols: [],
    currentlySelectedTable: null,
    selectedTables: [],
    tableViewColumns: null,
    updateInDbData: null,
}, action) => {
    switch (action.type) {
        case DATASET_BUILDER_ERASE_UPDATE_IN_DB:
            return {
                ...state,
                updateInDbData: null
            }
        case DATASET_BUILDER_DELETE_SELECTED_TABLE:
            const temp = [...state.selectedTables];
            const tableIdxToDelete = temp.findIndex(t => t.id === action.id);
            if (tableIdxToDelete === -1) {
                return state;
            }
            temp.splice(tableIdxToDelete, 1);
            return {...state, selectedTables: temp}
        case DATASET_BUILDER_ADD_MODIFY_SELECTED_TABLE:
            const newSelectedTable = {
                ...state.currentlySelectedTable,
                type: state.currentlySelectedTable.type !== "table" && state.currentlySelectedTable.type !== "view" ? "view" : state.currentlySelectedTable.type,
                filter: state.filter,
                filterTemp: state.filterTemp,
                treeFilter: state.treeFilter,
                treeFilterTemp: state.treeFilterTemp,
                filterMode: state.filterMode,
                filterStr: state.filterStr,
                aliasCols: state.aliasCols,
            };
            const newSelectedTables = [...state.selectedTables];
            if (!newSelectedTable.id) {
                newSelectedTable.id = uuidv4();
                newSelectedTables.push(newSelectedTable)
            } else {
                const tableIdx = newSelectedTables.findIndex(t => t.id === newSelectedTable.id);
                if (tableIdx === -1) {
                    return state;
                }
                newSelectedTables[tableIdx] = newSelectedTable;
            }
            return {...state, selectedTables: newSelectedTables}
        case DATASET_BUILDER_WIZARD_QUERY_REPLACE_QUERY:
            return {...state, query: action.query}
        case DATASET_BUILDER_CLEAN_SELECTED_TABLES:
            return {...state, selectedTables: []}
        case DATASET_BUILDER_CLEAR_AFTER_MODAL_HIDING:
            return {
                ...state,
                filter: null,
                filterTemp: null,
                treeFilter: {},
                treeFilterTemp: {},
                filterMode: QUERY_FORM_FILTER_MODE_PLAIN,
                rows: null,
                query: "",
                filterStr: "",
                aliasCols: [],
                currentlySelectedTable: null,
                updateInDbData: null
            };
        case DATASET_BUILDER_SELECT_CURRENT_TABLE:
            if (!action.table || !action.table.id) {
                return {...state, currentlySelectedTable: action.table};
            }
            return {
                ...state,
                currentlySelectedTable: action.table,
                filter: action.table.filter,
                filterTemp: !!action.table.filterTemp && Object.keys(action.table.filterTemp).length > 0 ? action.table.filterTemp : action.table.filter,
                treeFilter: action.table.treeFilter,
                treeFilterTemp: !!action.table.treeFilterTemp && Object.keys(action.table.treeFilterTemp).length > 0 ? action.table.treeFilterTemp : action.table.treeFilter,
                filterMode: action.table.filterMode,
                filterStr: action.table.filterStr,
                aliasCols: action.table.aliasCols,
            };
        case DATASET_BUILDER_CLEAR_QUERY_FETCHES:
            return {
                ...state,
                filter: null,
                filterTemp: null,
                treeFilter: {},
                treeFilterTemp: {},
                filterMode: QUERY_FORM_FILTER_MODE_PLAIN,
                filterStr: "",
                aliasCols: [],
            }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD: {
            const block = {
                column: null,
                logicalOperator: 'OR',
                conditions: null
            };
            return {
                ...state,
                filterTemp:
                    state.filterTemp !== null
                        ? (
                            [
                                ...state.filterTemp,
                                block
                            ]
                        )
                        : [block]
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            const condition = {
                comparisonOperator: null,
                value: null
            };
            if (filterTemp[action.blockIndex].conditions !== null) {
                filterTemp[action.blockIndex].conditions.push(condition);
            } else {
                filterTemp[action.blockIndex].conditions = [condition];
            }
            return {
                ...state,
                filterTemp: filterTemp
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            if (action.fields.filter.filter(block => block.column !== undefined).length > 0) {
                action.fields.filter = action.fields.filter.map(block => ({
                    ...block,
                    conditions: null
                }));
            }
            return {
                ...state,
                filterTemp: _.merge(filterTemp, action.fields.filter)
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE:
            return {
                ...state,
                filterMode: action.filterMode,
                filterTemp: [],
                treeFilterTemp: {}
            };
        case DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE:
            return {
                ...state,
                treeFilterTemp: action.treeFilter
            };
        case DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE: {

            let tableViewColumns = _.cloneDeep(state.tableViewColumns);
            const treeFilterTemp = _.cloneDeep(state.treeFilterTemp);

            treeFilterTemp[action.colName] = {
                mode: action.mode,
                values: treeFilterTemp[action.colName] && treeFilterTemp[action.colName].values
                    ? treeFilterTemp[action.colName].values
                    : []
            };

            const colNames =
                _.flatten(Object.keys(state.tableViewColumns).map(key => state.tableViewColumns[key]))
                    .map(({name}) => name);

            const colIndex = colNames.indexOf(action.colName);

            const subsequentColNames = colNames.splice(colIndex + 1);

            // delete filters for subsequent cols
            subsequentColNames.forEach(name => {
                delete treeFilterTemp[name];
            });

            // delete filteredCodelistTree for subsequent cols
            tableViewColumns = _.mapValues(tableViewColumns, colArr =>
                colArr.map(col =>
                    subsequentColNames.includes(col.name)
                        ? ({
                            ...col,
                            filteredCodelistTree: null
                        })
                        : col
                ));

            return {
                ...state,
                tableViewColumns,
                treeFilterTemp: treeFilterTemp
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE: {

            const treeFilterTemp = _.cloneDeep(state.treeFilterTemp);

            treeFilterTemp[action.colName] = {
                mode: treeFilterTemp[action.colName] && treeFilterTemp[action.colName].mode
                    ? treeFilterTemp[action.colName].mode
                    : FILTER_MODE_IN,
                values: action.values
            };

            const colNames =
                _.flatten(Object.keys(state.tableViewColumns).map(key => state.tableViewColumns[key]))
                    .map(({name}) => name);

            const colIndex = colNames.indexOf(action.colName);

            const subsequentColNames = colNames.splice(colIndex + 1);

            // delete filters for subsequent cols
            subsequentColNames.forEach(name => {
                delete treeFilterTemp[name];
            });

            return {
                ...state,
                tableViewColumns: _.mapValues(state.tableViewColumns, colArr => // delete filteredCodelistTree for subsequent cols
                    colArr.map(col => {
                        if (subsequentColNames.includes(col.name)) {
                            return ({
                                ...col,
                                filteredCodelistTree: null
                            });
                        } else {
                            return col;
                        }
                    })),
                treeFilterTemp: treeFilterTemp
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            filterTemp.splice(action.blockIndex, 1);
            return {
                ...state,
                filterTemp: filterTemp
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE: {
            const filterTemp = _.cloneDeep(state.filterTemp);
            filterTemp[action.blockIndex].conditions.splice(action.conditionIndex, 1);
            return {
                ...state,
                filterTemp: filterTemp
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET:
            return {
                ...state,
                filterTemp: [],
                treeFilterTemp: {}
            };
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET_ALL:
            return {
                ...state,
                filter: [],
                filterTemp: [],
                treeFilter: {},
                treeFilterTemp: {},
                filterStr: "",
            };
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET: {
            let tableViewColumns = _.cloneDeep(state.tableViewColumns);
            tableViewColumns = _.mapValues(tableViewColumns, colArr =>
                colArr.map(col =>
                    col.Code === action.columnName
                        ? ({
                            ...col,
                            values: null,
                            valuesCount: null
                        })
                        : col
                ));

            return {
                ...state,
                tableViewColumns
            };
        }
        case DATASET_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT:
            return {
                ...state,
                isFilterModalVisible: false,
                filter: state.filterMode === QUERY_FORM_FILTER_MODE_PLAIN ? action.filter : state.filter,
                filterTemp: null,
                treeFilter: state.filterMode === QUERY_FORM_FILTER_MODE_TREE ? action.filter : state.treeFilter,
                treeFilterTemp: {},
                filterStr: action.filterStr,
            };
        case DATASET_BUILDER_ADD_ALIAS_COLS:
            return {
                ...state,
                aliasCols: [...state.aliasCols, ...action.cols]
            }
        case DATASET_BUILDER_REORDER_ALIAS_COLS:
            return {
                ...state,
                aliasCols: [...action.cols]
            }
        case DATASET_BUILDER_REMOVE_ALIAS_COL:
            const newAliasCols = [...state.aliasCols];
            const aliasColIdx = newAliasCols.findIndex(item => item.colID === action.colID);
            if (aliasColIdx === -1) {
                return state;
            }
            newAliasCols.splice(aliasColIdx, 1);
            return {
                ...state,
                aliasCols: newAliasCols
            }
        case DATASET_BUILDER_UPDATE_ALIAS_COL:
            const updatedAliasCols = [...state.aliasCols];
            const updatedAliasColIdx = updatedAliasCols.findIndex(item => item.colID === action.colID);
            if (updatedAliasColIdx === -1) {
                return state;
            }
            updatedAliasCols[updatedAliasColIdx] = {...updatedAliasCols[updatedAliasColIdx], colValue: action.alias};
            return {
                ...state,
                aliasCols: updatedAliasCols
            }
        case REQUEST_ERROR:
            switch (action.label) {
                case DATASET_BUILDER_UPDATE_IN_DB:
                    return {
                        ...state,
                        updateInDbData: null
                    }
                default:
                    return state;
            }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case DATASET_BUILDER_UPDATE_IN_DB:
                    return {
                        ...state,
                        updateInDbData: action.response
                    }
                case DATASET_BUILDER_GET_TABLE_VIEW_COLUMNS_FOR_MODAL:
                    return {
                        ...state,
                        tableViewColumns: {
                            dimensions: action.response.map(Code => ({
                                Code,
                                name: Code,
                                disabled: false,
                                values: [],
                                filteredValues: [],
                                filteredCodelistTree: null,
                                CodelistCode: Code,
                                codelistCount: 1
                            }))
                        }
                    };
                case DATASET_BUILDER_WIZARD_QUERY_APPEND_QUERY:
                    return {
                        ...state, query: `${state.query}${!!state.query ? '\n' : ''}SELECT ${action.response.map(name => wrapColumnWithDBSpecificParenthesis(name, action.dbType)).join(", ")} FROM ${action.tableName}`
                    }
                case DATASET_BUILDER_GET_DATASET:
                    return {
                        ...state,
                        query: action.response.query || "",
                        updateInDbData: action.response.columns ? action.response.columns : []
                    }
                case DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ: {
                    const responseColumnIndex = action.response.columns.findIndex(col => col === action.columnName);
                    if (responseColumnIndex === -1) {
                        return state;
                    }
                    let columnValues = [...new Set(action.response.rows.map(val => val[responseColumnIndex]))].sort();

                    let tableViewColumns = _.cloneDeep(state.tableViewColumns);
                    tableViewColumns = _.mapValues(tableViewColumns, colArr =>
                        colArr.map(col =>
                            col.Code === action.columnName
                                ? ({
                                    ...col,
                                    values: columnValues.map(val => ({[action.columnName]: val})),
                                    valuesCount: action.response.totalRows
                                })
                                : col
                        ));

                    return {
                        ...state,
                        tableViewColumns
                    };
                }
                case DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ: {
                    const responseColumnIndex = action.response.columns.findIndex(col => col === action.colName);
                    if (responseColumnIndex === -1) {
                        return state;
                    }
                    let filteredValues = [...new Set(action.response.rows.map(val => val[responseColumnIndex]))].sort();

                    let tableViewColumns = _.cloneDeep(state.tableViewColumns);
                    tableViewColumns = _.mapValues(tableViewColumns, colArr =>
                        colArr.map(col => {
                            if (col.name === action.colName) {

                                const filteredCodelistTree =
                                    filteredValues.map(item => ({"id": item, "name": {"en": item, "it": item}}))

                                return ({
                                    ...col,
                                    filteredCodelistTree,
                                    filteredValues,
                                    filteredCodelistTreeMaxDepth: 1
                                });
                            } else
                                return col;
                        }));

                    return {
                        ...state,
                        tableViewColumns
                    };
                }
                default:
                    return state;
            }
        default:
            return state;
    }
};

export default UnionModalPropsReducer;
